import { CalendarDaysIcon, ChartPieIcon, GlobeAltIcon, InboxArrowDownIcon, KeyIcon, Squares2X2Icon, TagIcon, UsersIcon } from '@heroicons/react/24/outline';

// The reports of the BI rail, in the order of the rail.
export const REPORTS = [
	{ id: 'dashboard', label: 'Dashboard', icon: Squares2X2Icon, title: 'Coming soon' },
	// ROO2-293 D1: Daily performance is the first report, after the Dashboard and above Segmentation (replaces ROO2-288 D5).
	{ id: 'daily-performance', label: 'Daily performance', icon: CalendarDaysIcon },
	// ROO2-314 (D16): Pick-up monitoring, after Daily performance.
	{ id: 'pickup-monitoring', label: 'Pick-up monitoring', icon: InboxArrowDownIcon },
	{ id: 'segmentation', label: 'Segmentation', icon: ChartPieIcon },
	{ id: 'room-types', label: 'Room types', icon: KeyIcon },
	{ id: 'rate-plans', label: 'Rate plans', icon: TagIcon },
	{ id: 'guest-mix', label: 'Guest Mix', icon: UsersIcon },
	{ id: 'channels', label: 'Channels', icon: GlobeAltIcon },
];

export type BiReport = typeof REPORTS[number];

// The groups of the rail: the Dashboard alone, then every other report of the list, so none can be left out (ROO2-293 D2).
export const biRailGroups = <T>(items: T[]): T[][] => [[items[0]], items.slice(1)];
